<template>
    <div class="page home-page">
        <v-container class="py-lg-6" :class="{'px-0': phoneOnly}">
            <transition name="fade-transition">
                <div v-if="homeData">
                    <v-row v-if="stats" class="stats">
                        <v-col cols="12" lg="4">
                            <stat-card label="الطلاب" :value="stats.students" color="primary" icon="mdi-account-group"/>
                        </v-col>
                        <v-col cols="12" lg="4">
                            <stat-card label="الدورات" :value="stats.courses" color="indigo" icon="mdi-play-box-multiple"/>
                        </v-col>
                        <v-col cols="12" lg="4">
                            <stat-card label="المحاضرات" :value="stats.lectures" color="deep-orange" icon="mdi-motion-play"/>
                        </v-col>
                        <v-col cols="12" lg="4">
                            <stat-card label="الامتحانات" :value="stats.exams" color="strong-text" icon="mdi-clipboard-text-multiple-outline"/>
                        </v-col>
                        <v-col cols="12" lg="4">
                            <stat-card label="جلسات الامتحانات" :value="stats.exam_sessions" color="deep-purple" icon="mdi-clipboard-check-multiple"/>
                        </v-col>
                        <v-col cols="12" lg="4">
                            <stat-card label="الأسئلة" :value="stats.questions" color="strong-text" icon="mdi-file-question-outline"/>
                        </v-col>
                        <v-col cols="12" lg="4">
                            <stat-card label="بطاقات الدفع" :value="stats.paycards" color="orange darken-1" icon="mdi-credit-card-multiple-outline"/>
                        </v-col>
                        <v-col cols="12" lg="4">
                            <stat-card label="عمليات الشراء" :value="stats.purchases" color="success" icon="mdi-order-bool-descending-variant"/>
                        </v-col>
                        <v-col cols="12" lg="4">
                            <stat-card label="عمليات الشراء المدفوعة" info="عمليات الشراء لعناصر غير مجانية، باستخدام بطاقة دفع أو الطرق المتاحة اﻷخرى (إن وُجد)" :value="stats.paid_purchases" color="success" icon="mdi-order-bool-descending-variant"/>
                        </v-col>
                    </v-row>

                    <v-card class="card-shadow my-5 my-lg-8 px-1 px-lg-3">
                        <v-card-title>قائمة دوراتك</v-card-title>
                        <v-card-subtitle>قائمة الدورات المرتبطة بحسابك كمعلم</v-card-subtitle>
                        <v-card-text class="pt-2 pb-6" >
                            <v-row v-if="courses && courses.length">
                                <v-col cols="12" md="6" lg="3" v-for="course in courses" :key="course.id">
                                    <course-card :course="course" short />
                                </v-col>
                            </v-row>
                            <div v-else>
                                <v-alert dense type="info" color="blue-grey" text class="mb-1">
                                    <span class="details-text">لم نعثر على أي دورات مرتبطة بحسابك</span>
                                </v-alert>
                            </div>
                        </v-card-text>
                    </v-card>
                </div>
            </transition>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import StatCard from '@/components/default/stat-card'
import CourseCard from '@/components/custom/course-card'

export default {
    name: "Home",
    components: {
        StatCard,
        CourseCard
    },
    data(){
        return {
            loading: false,

        }
    },
    computed: {
        ...GlobalComputed,
        homeData(){
            return this.$store.state.globalModule.homeData;
        },
        courses(){
            return this.homeData && this.homeData.courses ? this.homeData.courses : [];
        },
        stats(){
            return this.homeData ? this.homeData.stats : null;
        },
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                this.$store.dispatch('loadHomeData').then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        }
    },
    mounted(){
        this.loadData();
    }
};
</script>
<style lang="scss" scoped>
.stats{
    margin: -8px;
    .col-lg-3, .col-lg-4{
        padding: 8px!important;
    }
}
</style>
